import { Redirect, useLocation } from 'react-router-dom';
import IntentWorkspace from 'src/screens/IntentWorkspace';
import { readIntentHandoff } from 'src/utils/intentHandoff';

/** Preserve handoff/commerce workflows while old bookmarks open the current cabinet. */
export function workspaceDestination(search: string, handoff: boolean): string | null {
    const params = new URLSearchParams(search);
    const view = params.get('view');
    if (handoff || ['order', 'new_dialog', 'conversation', 'search', 'help'].some((key) => params.has(key)))
        return null;
    const id = params.get('project');
    if (params.get('new') === '1') return '/leadstream';
    if (view === 'projects' || (!id && !view)) return '/leadstream';
    if (id && (!view || ['leads', 'funnel', 'business', 'knowledge'].includes(view))) {
        return '/leadstream?' + new URLSearchParams({ draft: id }).toString();
    }
    return null;
}

export default function WorkspaceEntry() {
    const { search } = useLocation();
    const handoff = Boolean(readIntentHandoff('draft') || readIntentHandoff('gift') || readIntentHandoff('referral'));
    const destination = workspaceDestination(search, handoff);
    return destination ? <Redirect to={destination} /> : <IntentWorkspace />;
}
